import { Component, Input } from '@angular/core';
import { PaymentTypeValues } from '@timechef/core/api';
import { AuthRepository } from '@timechef/core/auth';
import { isNullOrUndefined } from '@timechef/core/utils/js-utils';
import { map } from 'rxjs';

@Component({
  selector: 'app-reload-button',
  templateUrl: './reload-button.component.html',
  styleUrls: ['./reload-button.component.scss'],
  standalone: false,
})
export class ReloadButtonComponent {
  accountBalanceDS$ = this.authRepo.accountBalanceDS.data$();
  isReloadTextShowable = this.authRepo.userPaymentType$.pipe(map((x) => x !== PaymentTypeValues.PostPaiement));

  @Input() showReloadTextWithoutWarning = false;
  @Input() forceAlert = false;
  @Input()
  link: any[] | string | null = null;
  constructor(private authRepo: AuthRepository) {}

  hasBalanceAlert(balanceData?: number) {
    if (this.forceAlert) return true;

    if (isNullOrUndefined(balanceData)) return false;

    if (this.authRepo.getUserPaymentType() === PaymentTypeValues.PostPaiement) return false;

    const balanceAlert = this.authRepo.getBalanceAlert();

    return balanceAlert.userAmount ? balanceAlert.userAmount > balanceData : balanceAlert.siteAmount > balanceData;
  }
}
